import { MessageGateway } from './message-gateway.interface';

const baseUrl = 'gk/projects';
export class HttpMessageGateway implements MessageGateway {
  getMessagesByProject(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/messages`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  postMessage(args: { taskId: string; content: string }) {
    return {
      url: `${baseUrl}/${args.taskId}/messages`,
      method: 'POST',
      data: { content: args.content },
    };
  }

  patchMessage(args: { messageId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.messageId}/messages`,
      method: 'PATCH',
      data: args.data,
    };
  }

  deleteMessage(args: { messageId: string }) {
    return {
      url: `${baseUrl}/${args.messageId}/messages`,
      method: 'DELETE',
    };
  }
}
